import { render, staticRenderFns } from "./followBus.vue?vue&type=template&id=397bfca2&"
import script from "./followBus.vue?vue&type=script&lang=js&"
export * from "./followBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports